import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Table, Popup, Button, Icon } from "semantic-ui-react";
import { RootStoreContext } from "../../../app/stores/rootStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import EditPachageForm from "./EditPachageForm";
import { getDateFormatPackage } from "../../../app/util/dateOptions";

const ListPackages = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { getPackages, loadData, packages } = rootStore.packageStore;
  const { openModal } = rootStore.modalStore;

  useEffect(() => {
    getPackages();
  }, [getPackages]);

  if (!loadData) return <LoadingComponent content="Cargando" />;

  return (
    <div className="TableScroll">
    <Table striped basic fixed unstackable compact singleLine>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>No facturas</Table.HeaderCell>
          <Table.HeaderCell>Valor pago</Table.HeaderCell>
          <Table.HeaderCell>Fecha de pago</Table.HeaderCell>
          <Table.HeaderCell>Fecha fin paquete</Table.HeaderCell>
          <Table.HeaderCell>Acciones</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {packages?.length > 0 ? (
          packages.map((p) => (
            <Table.Row key={p.id}>
              <Table.Cell>{p.numberOfDocuments}</Table.Cell>
              <Table.Cell>{p.price}</Table.Cell>
              <Table.Cell>{getDateFormatPackage(p.paymentDate)}</Table.Cell>
              <Table.Cell>{getDateFormatPackage(p.expirationDate)}</Table.Cell>
              <Table.Cell>
                <Popup
                  content="Editar paquete"
                  trigger={
                    <Button
                      icon
                      onClick={() =>
                        openModal(
                          <EditPachageForm packageForm={p} />,
                          "Editando paquete"
                        )
                      }
                    >
                      <Icon name="edit outline" color="blue" />
                    </Button>
                  }
                />
              </Table.Cell>
            </Table.Row>
          ))
        ) : (
          <Table.Row key="packagesNull">
            <Table.Cell>No existen paquetes</Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table>
    </div>
  );
};

export default observer(ListPackages);
